import { useRouter } from 'next/router'
import { PaginationProps } from '@arco-design/web-react'

export const RenderCanonical = (host = 'echotik.live') => {
  const router = useRouter()
  const originUrl = `https://${host}${router.asPath}`
  const urlParts = originUrl.split('?')
  const baseUrl = urlParts[0]
  return <link rel="canonical" href={baseUrl}></link>
}

const libraryPaths = ['/influencers', '/products', '/shops', '/live']

export const RenderPageLink = (tableData: boolean | PaginationProps | undefined) => {
  const router = useRouter()
  const { pathname, query, asPath } = router
  const curPage = query.page
  let maxPage = 0

  if (tableData && typeof tableData === 'object') {
    if (tableData?.total && tableData?.pageSize) {
      maxPage = Math.ceil(tableData?.total / tableData?.pageSize)
    }
  }

  if (pathname.includes('/page/') && curPage) {
    const curPageNum = Number(curPage)

    const nextHref = pathname.replace('[page]', `${curPageNum + 1}`)
    if (curPageNum === 1) {
      return <link rel="next" href={nextHref} />
    } else if (curPageNum === 2) {
      const prevHref = pathname.replace('/page/[page]', '')
      return (
        <>
          <link rel="prev" href={prevHref} />
          <link rel="next" href={nextHref} />
        </>
      )
    } else if (maxPage > 0 && curPageNum === maxPage) {
      // 最后一页
      const prevHref = pathname.replace('[page]', `${curPageNum - 1}`)
      return (
        <>
          <link rel="prev" href={prevHref} />
        </>
      )
    } else {
      const prevHref = pathname.replace('[page]', `${curPageNum - 1}`)
      return (
        <>
          <link rel="prev" href={prevHref} />
          <link rel="next" href={nextHref} />
        </>
      )
    }
  } else if (libraryPaths.includes(pathname) && !pathname.includes('/page/')) {
    // 库
    return <link rel="next" href={`${pathname}/page/2`} />
  } else if (pathname.includes('/leaderboard/') && !pathname.includes('/page/') && asPath) {
    // 非seo榜单
    const urlArr = asPath.split('?')
    const basePath = urlArr[0]
    return <link rel="next" href={`${basePath}/page/2`} />
  }
  return null
}
